import { defineMessages } from 'react-intl';

export const HomeMessages = defineMessages({
  home: {
    id: 'HomePage.home',
    defaultMessage: 'Home',
    description: 'Home',
  },
  recentActivity: {
    id: 'HomePage.recentActivity',
    defaultMessage: 'Recent Activity',
    description: 'Header for a visual for a recent job',
  },
  homeHeader: {
    id: 'Home.homeHeader',
    defaultMessage: 'Home',
  },
  homeControllerConnectionSuccessMessage: {
    id: 'Home.homeControllerConnectionSuccessMessage',
    defaultMessage: 'Success! Controller has been connected.',
  },
  homeControllerConnectionSuccessOtherOrgMessage: {
    id: 'Home.homeControllerConnectionSuccessOtherOrgMessage',
    defaultMessage: 'Warning! Controller has been connected, but it belongs to another organization.',
  },
  homeMenuUploadLogLabel: {
    id: 'Home.homeMenuUploadLogLabel',
    defaultMessage: 'Upload Job',
  },
  homeActiveUsersCount: {
    id: 'Home.activeUsersCount',
    defaultMessage: 'Active Users',
  },
  homeStoneAgeResourcesTitle: {
    id: 'Home.stoneAgeResourcesTitle',
    defaultMessage: 'StoneAge Resources',
    description: 'Page section title for StoneAge resources',
  },
  viewAllJobs: {
    id: 'Home.viewAllJobs',
    defaultMessage: 'View all',
  },
  stoneAgeNewsUpdates: {
    id: 'Home.stoneAgeNewsUpdates',
    defaultMessage: 'Updates',
  },
  stoneAgeNewsSentinelLink: {
    id: 'Home.stoneAgeNewsSentinelLink',
    defaultMessage: 'Sentinel Link',
  },
  stoneAgeNewsFirmware: {
    id: 'Home.stoneAgeNewsFirmware',
    defaultMessage: 'Firmware',
  },
  firmwareVersionUpdateAvailable: {
    id: 'Home.firmwareVersionUpdateAvailable',
    defaultMessage: 'New controller version is available.',
  },
  firmwareVersionUpdateAvailableBody: {
    id: 'Home.firmwareVersionUpdateAvailableBody',
    defaultMessage: 'Would you like to update?',
  },
  accessDeniedTitle: {
    id: 'Home.accessDeniedTitle',
    defaultMessage: 'Access Denied',
  },
  accessDeniedMessage: {
    id: 'Home.accessDeniedMessage',
    defaultMessage: 'Your account does not have access to Sentinel Link. Contact StoneAge for more information.',
  },
  accessDeniedContactStoneAge: {
    id: 'Home.accessDeniedContactStoneAge',
    defaultMessage: 'Contact StoneAge',
  },
  clickHereToSignIn: {
    id: 'Home.clickHereToSignIn',
    defaultMessage: 'Click here if you are not signed in automatically',
  },
  redirectingToStoneAgeSignInTitle: {
    id: 'Home.redirectingToStoneAgeSignInTitle',
    defaultMessage: 'Redirecting to StoneAge Sign In',
  },
  loggedOutTitle: {
    id: 'Home.loggedOutTitle',
    defaultMessage: 'You have signed out of Sentinel Link.',
  },
  reviewTosHeader: {
    id: 'Home.tos.header',
    defaultMessage: 'Please review and accept our Terms and Conditions.',
  },
  reviewTosHeaderGuest: {
    id: 'Home.tos.header.guest',
    defaultMessage: 'Welcome, guest! Please review and accept our Terms and Conditions.',
  },
  reviewTosTermsButton: {
    id: 'Home.tos.termsButton',
    defaultMessage: 'Review Terms of Service',
  },
  reviewTosPrivacyButton: {
    id: 'Home.tos.privacyButton',
    defaultMessage: 'Review Privacy Policy',
  },
  reviewTosAgreeButton: {
    id: 'Home.tos.agreeButton',
    defaultMessage: 'I Agree',
  },
  subscriptionPageHeader: {
    id: 'Home.subscriptionPageheader',
    defaultMessage: 'Subscriptions',
  },
  connectToController: {
    id: 'Home.connectToController',
    defaultMessage: 'Connect to Controller',
  },
});
